<template>
  <div class="maxbox">
    <div>
      <div class="top">
        <button class="return" @click="goback">
          <img src="@/assets/images/left-arrow.png" alt="" />
        </button>
      </div>

      <div class="main">
        <div class="itemheader" style="margin-top: 10px;">
          <img src="@/assets/images/ban-2.png" alt="">
          <div>
            <img src="@/assets/images/kj2.png" alt="" style="width:100%; height: 100%;">
          </div>
        </div>

        <h3 class="title" style="color: #000;">礦機明细</h3>

        <div class="card" style="background-color: rgba(245,245,245,0.8);display:flex;flex-direction:column;justify-content:space-around;">
          <div class="bet">
            <p style="color: #000;">我的礦機总数量：</p>
            <p style="color: #000;">{{ myTotalMachines }}台</p>
          </div>
          <div class="bet">
            <p style="color: #000;">我的1号礦機：</p>
            <p style="color: #000;">{{ myOneMachineCount }}台</p>
          </div>
          <div class="bet">
            <p style="color: #000;">我的2号礦機：</p>
            <p style="color: #000;">{{ myTwoMachineCount }}台</p>
          </div>
          <div class="bet">
            <p style="color: #000;">我的3号礦機：</p>
            <p style="color: #000;">{{ myThreeMachineCount }}台</p>
          </div>
          <div class="bet">
            <p style="color: #000;">我的团队礦機总数量：</p>
            <p style="color: #000;">{{ teamMachines }}台</p>
          </div>

          <div class="bet">
            <p style="color: #000;">我的团队1号礦機数量：</p>
            <p style="color: #000;">{{ teamOneMachineCount }}台</p>
          </div>

          <div class="bet">
            <p style="color: #000;">我的团队2号礦機数量：</p>
            <p style="color: #000;">{{ teamTwoMachineCount }}台</p>
          </div>
          <div class="bet">
            <p style="color: #000;">我的团队3号礦機数量：</p>
            <p style="color: #000;">{{ teamThreeMachineCount }}台</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { usdtTokenAddress, usdtAbi, contractAddress, contractABI } from '@/js/contract.js';

export default {
  name: 'item',
  data() {
    return {
      myTotalMachines: 0,
      myOneMachineCount: 0,
      myTwoMachineCount: 0,
      myThreeMachineCount: 0,
      teamMachines: 0,
      teamOneMachineCount: 0,
      teamTwoMachineCount: 0,
      teamThreeMachineCount: 0,
      walletAddress: '未连接',
      shortWalletAddress: '未连接',
      walletBalanceTop: '0'
    }
  },
  mounted() {
    this.connectWallet();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async connectWallet() {
      if (window.ethereum) {
        try {
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          await provider.send("eth_requestAccounts", []);
          const signer = provider.getSigner();
          const address = await signer.getAddress();

          const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, provider);
          const balance = await usdtContract.balanceOf(address);
          const balanceInUsdt = ethers.utils.formatUnits(balance, 18);
          const balanceInUsdtInt = Math.floor(balanceInUsdt);

          this.walletAddress = address;
          this.shortWalletAddress = `${address.slice(0, 6)}...${address.slice(-4)}`;
          this.walletBalanceTop = balanceInUsdtInt;

          this.fetchMachineCounts(signer);
        } catch (error) {
          console.error(error);
          alert('连接钱包失败');
        }
      } else {
        alert('请安装 MetaMask 插件');
      }
    },
    async fetchMachineCounts(signer) {
      try {
        const contract = new ethers.Contract(contractAddress, contractABI, signer);

        const [
          myTotalMachines,
          myOneMachineCount,
          myTwoMachineCount,
          myThreeMachineCount
        ] = await contract.getMemberMachines(this.walletAddress);

        const teamMachines = await contract.getTeamMachineCount(this.walletAddress);
        
        const [teamOne, teamTwo, teamThree] = await contract.getTeamMachineCounts(this.walletAddress);

        this.myTotalMachines = parseInt(myTotalMachines);
        this.myOneMachineCount = parseInt(myOneMachineCount);
        this.myTwoMachineCount = parseInt(myTwoMachineCount);
        this.myThreeMachineCount = parseInt(myThreeMachineCount);
        this.teamMachines = parseInt(teamMachines);

        this.teamOneMachineCount = parseInt(teamOne);
        this.teamTwoMachineCount = parseInt(teamTwo);
        this.teamThreeMachineCount = parseInt(teamThree);

      } catch (error) {
        console.error('Error fetching machine counts:', error);
        alert('获取服务器数据失败，请重试');
      }
    }
  }
}
</script>

<style scoped>
@import "@/assets/css/item.css";

.card {
  padding: 10px;
  margin: 10px 0;
  border-radius: 8px;
  background-color: #f0f0f0;
  overflow: auto;
  max-height: 300px;
 
}

.bet {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

p {
  color: #000;
}

h3 {
  color: #000;
}

.top {
  position: relative;
  z-index: 9999 !important;
}
.return {
  display: block;
  width: 44px;
  height: 44px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 9999 !important;
  position: relative;
}

.itemheader {
  position: relative;
  z-index: 1 !important;
}
</style>